import { MATRIX_DISPLAY_STATE_LABELS, type MatrixDisplayState } from '@/lib/matrix-grid-search';
import { cn } from '@/lib/utils';
import { Spinner } from '@pms-digital/design-system';

export interface MatrixStateBadgeProps {
  state: MatrixDisplayState;
}

/** A state's colour carries its meaning: success vert, running bleu-ciel, failure rouge. */
const STATE_CLASSES: Readonly<Record<MatrixDisplayState, string>> = {
  terminee: 'bg-vert-tint text-vert-deep',
  en_cours: 'bg-bleu-ciel-tint text-bleu-ciel-deep',
  echec: 'bg-rouge-tint text-rouge-deep',
  brouillon: 'bg-gray-100 text-gray-600',
};

/** The state pill of a matrix card and of a list row. */
export function MatrixStateBadge({ state }: MatrixStateBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-0 font-semibold text-caption',
        STATE_CLASSES[state],
      )}
    >
      {state === 'en_cours' && <Spinner size="xs" label="" />}
      {MATRIX_DISPLAY_STATE_LABELS[state]}
    </span>
  );
}
